<template>
  <div class="mainapp">
    <!-- Logo -->
    <div class="logo-container">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        
        viewBox="0 0 120.531 54"
      >
        <defs>
          <clipPath id="clip-path">
            <rect
              id="Rechteck_5"
              data-name="Rechteck 5"
              width="120.53"
              height="54"
              transform="translate(0 0)"
              fill="none"
            />
          </clipPath>
        </defs>
        <g id="Gruppe_5" data-name="Gruppe 5" transform="translate(0 0)">
          <g
            id="Gruppe_4"
            data-name="Gruppe 4"
            transform="translate(0 0)"
            clip-path="url(#clip-path)"
          >
            <path
              id="Pfad_15"
              data-name="Pfad 15"
              d="M173.34,53.618V50.8h7.248v6.362a8.555,8.555,0,0,1-7.107,3.332c-4.941,0-8.692-3.426-8.692-8.436a8.492,8.492,0,0,1,8.692-8.436,8.791,8.791,0,0,1,6.851,3.216l-2.307,2a6.011,6.011,0,0,0-4.544-2.307,5.225,5.225,0,0,0-5.127,5.523c0,3.263,2.027,5.523,5.127,5.523a5.59,5.59,0,0,0,3.775-1.515V53.618Z"
              transform="translate(-94.654 -25.056)"
              fill="#00616f"
            />
            <path
              id="Pfad_16"
              data-name="Pfad 16"
              d="M214.72,60.494a8.437,8.437,0,1,1,8.529-8.436,8.416,8.416,0,0,1-8.529,8.436m0-13.959c-2.89,0-4.987,2.424-4.987,5.523s2.1,5.523,4.987,5.523c2.866,0,4.964-2.423,4.964-5.523s-2.1-5.523-4.964-5.523"
              transform="translate(-118.423 -25.057)"
              fill="#00616f"
            />
            <path
              id="Pfad_17"
              data-name="Pfad 17"
              d="M261.544,60.591l-7.481-10.207V60.591h-3.332V44.278h2.936l7.551,10.231V44.278h3.332V60.591Z"
              transform="translate(-144.02 -25.433)"
              fill="#00616f"
            />
            <path
              id="Pfad_18"
              data-name="Pfad 18"
              d="M35.622,60.591V53.6H28.7v6.991H25.242V44.278H28.7v6.5h6.921v-6.5h3.464V60.591Z"
              transform="translate(-14.499 -25.433)"
              fill="#00616f"
            />
            <path
              id="Pfad_19"
              data-name="Pfad 19"
              d="M62.7,60.608V44.3H73.473v2.82H66.128V50.8h7.345v2.82H66.128v4.172h7.345v2.82Z"
              transform="translate(-36.012 -25.443)"
              fill="#00616f"
            />
            <path
              id="Pfad_20"
              data-name="Pfad 20"
              d="M101.723,60.589,98.064,55l-3.682,5.593H90.3l5.686-8.3-5.454-8.017h4.2l3.426,5.291,3.449-5.291h4.079l-5.454,7.971,5.686,8.343Z"
              transform="translate(-51.87 -25.432)"
              fill="#00616f"
            />
            <path
              id="Pfad_21"
              data-name="Pfad 21"
              d="M140.775,60.59,139.74,57.56h-5.727l-1.081,3.029h-3.658l6.579-16.313h2.668l6.05,16.313Zm-5.8-5.756h3.841l-1.863-5.477h-.023Z"
              transform="translate(-74.255 -25.433)"
              fill="#00616f"
            />
            <path
              id="Pfad_22"
              data-name="Pfad 22"
              d="M21.769,49.931,3.46,38.576V15.424L21.769,4.069l7.282,4.516L32.333,6.55,21.769,0,0,13.5v27L21.769,54l10.563-6.55-3.281-2.034Z"
              transform="translate(0 0)"
              fill="#02b0a4"
            />
            <path
              id="Pfad_23"
              data-name="Pfad 23"
              d="M49.632,15.424V13.5L71.4,0,93.171,13.5v1.923H89.709L71.4,4.07,53.1,15.424Zm0,23.153V40.5L71.4,54,93.171,40.5V38.576H89.709L71.4,49.93,53.1,38.576Z"
              transform="translate(-28.509 0)"
              fill="#049099"
            />
            <path
              id="Pfad_24"
              data-name="Pfad 24"
              d="M167.672,90.64a2.711,2.711,0,1,1,0,5.418h-.858v3.281h-1.533v-8.7Zm-.858,3.915h.611c.815,0,1.426-.311,1.426-1.181a1.144,1.144,0,0,0-1.222-1.23h-.815Z"
              transform="translate(-94.938 -52.064)"
              fill="#00616f"
            />
            <path
              id="Pfad_25"
              data-name="Pfad 25"
              d="M186.092,95.237c0,2.734-.9,4.25-3.045,4.25-2.1,0-3-1.516-3-4.25v-4.6h1.533v4.834c0,1.665.579,2.461,1.49,2.461s1.49-.8,1.49-2.461V90.639h1.533Z"
              transform="translate(-103.418 -52.063)"
              fill="#00616f"
            />
            <path
              id="Pfad_26"
              data-name="Pfad 26"
              d="M200.515,90.64a2.573,2.573,0,0,1,2.745,2.61,2.459,2.459,0,0,1-1.63,2.423c.664,1.081,1.78,2.858,2.294,3.666h-1.93l-2.059-3.467h-.268v3.467h-1.533v-8.7Zm-.847,3.728h.6c.772,0,1.351-.323,1.351-1.081a1.085,1.085,0,0,0-1.147-1.144h-.8Z"
              transform="translate(-113.809 -52.064)"
              fill="#00616f"
            />
            <path
              id="Pfad_27"
              data-name="Pfad 27"
              d="M219.475,95.237c0,2.734-.9,4.25-3.045,4.25-2.1,0-3-1.516-3-4.25v-4.6h1.533v4.834c0,1.665.579,2.461,1.49,2.461s1.49-.8,1.49-2.461V90.639h1.533Z"
              transform="translate(-122.593 -52.063)"
              fill="#00616f"
            />
            <path
              id="Pfad_28"
              data-name="Pfad 28"
              d="M233.551,91.806a.885.885,0,0,0-.976.87c0,.671.708.857,1.287,1.093,1.061.423,2.337.994,2.337,2.821a2.672,2.672,0,0,1-2.842,2.7,3.649,3.649,0,0,1-2.873-1.454l1.018-1.156a2.422,2.422,0,0,0,1.866,1.093,1.086,1.086,0,0,0,1.19-1.106c0-.746-.686-1.032-1.447-1.355-.976-.423-2.069-.92-2.069-2.585A2.325,2.325,0,0,1,233.5,90.29a3.593,3.593,0,0,1,2.488,1.031l-.879,1.267a2.386,2.386,0,0,0-1.555-.783"
              transform="translate(-132.391 -51.863)"
              fill="#00616f"
            />
          </g>
        </g>
      </svg>
    </div>
    <!-- CANVAS -->
    <div
      class="canvascontainer"
      :class="drawerIsOpen ? 'canvascontainer-active' : ''"
    >
      <PlayCanvas
        @appCreated="appCreated"
        @appProgress="appProgress"
        ref="pcapp"
      />
    </div>
    <!-- Sidebar -->
    <div class="sidebar">
      <!-- need this if no info icon displayed-->
      <div></div>
      <!-- <div class="sb-btn" @click="sidebarInfoClicked"><i class="fas fa-info-circle"></i></div> -->
      <div class="sb-btn" @click="sidebarMenuClicked">
        <i class="fas fa-bars"></i>
      </div>
    </div>
    <!-- Drawer -->
    <div
      class="drawer-container"
      :class="drawerIsOpen ? 'drawer-container-active' : ''"
      @mousedown="preventClickthru"
    >
      <div class="content-container">
        <transition name="content" v-for="s in scenes"
          :key="s.id">
          <div class="content-item" v-if="activeScene.id === s.id">
            <ContentDisplay 
              :item="s"
            />
          </div>
        </transition>
        <!-- <transition name="content">
          <div class="content-item" v-if="activeScene.id !== 'overview'">
            <ContentDisplay  
            :topic="'Sea'" />
          </div>
        </transition> -->
      </div>
      <div class="scenemenu">
        <MenuButton
          v-for="s in scenes"
          :key="s.id"
          @btnclicked="setActive"
          :id="s.id"
          :text="s.name"
          :activated="s.id === activeScene.id"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import PlayCanvas from "./components/Playcanvas.vue";
import MenuButton from "./components/MenuButton.vue";
import ContentDisplay from "./components/ContentDisplay.vue";

export default {
  name: "App",
  components: {
    PlayCanvas,
    MenuButton,
    ContentDisplay,
  },
  data: () => {
    return {
      drawerIsOpen: false,
    };
  },
  methods: {
    ...mapActions("scenes", [
      "loadScenes",
      "activateScene",
      "activateSceneName",
      "clearActivateScene",
    ]),

    setActive(c) {
      //this.activateScene(c);
      if (this.app) this.app.fire("scene:active:change", c);
    },
    resetScene() {
      this.clearActivateScene();
    },
    appCreated(app) {
      this.app = app;
      //add app listeners here
      this.app.on(
        "scene:active:set",
        function (sname) {
          this.activateSceneName(sname);
        },
        this
      );
    },
    appProgress(perc) {
      // console.log("loading progress "+perc);
      this.appPercent = perc;
      if (perc == 1) this.appLoaded = true;
    },
    doLoadApp() {
      this.$refs.pcapp.initApp();
    },
    toggleDrawer() {
      this.drawerIsOpen = !this.drawerIsOpen;
    },
    sidebarMenuClicked() {
      this.toggleDrawer();
    },
    sidebarInfoClicked() {},
    preventClickthru(e) {
      e.stopPropagation();
    },
  },
  computed: {
    ...mapState({
      scenes: (state) => state.scenes.all,
      activeScene: (state) => state.scenes.active,
    }),
  },
  created() {
    this.loadScenes();
    // this.loadScenes('data/testing.json');
  },
  mounted() {
    if (!this.app) this.doLoadApp();
  },
  watch: {
    activeScene: function (n) {
      //console.log("new active scene value=" + JSON.stringify(n));
      //this.drawerIsOpen = n.id !== "overview";
    },
  },
};
</script>

<style>
/* PlayCanvas */
.canvascontainer {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  z-index: 0;
  transition: var(--sidebar-drawer-transition);
}
.canvascontainer-active {
  left: calc(0.5 * var(--sidebar-drawer-width));
}

.scenemenu {
  padding-left: var(--menu-position-left);
  flex-grow: 0;
}
.scenebtn {
  width: 200px;
  height: 50px;
  padding: 6px;
  display: flex;
  justify-content: left;
  align-items: center;
  user-select: none;
  cursor: pointer;
  color: var(--primary-font-color);
  font-family: var(--hexagon-font-default);
}
.active {
  /* background-color: beige; */
  color: var(--hexagon-turquoise);
}
.drawer-container {
  width: var(--sidebar-drawer-width);
  background-color: var(--sidebar-bg-color);
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: calc(-1 * var(--sidebar-drawer-width));
  transition: var(--sidebar-drawer-transition);
  z-index: 4;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;
}
.drawer-container-active {
  left: var(--sidebar-width);
}
.btn-dev {
  position: absolute;
  top: 20px;
  right: 100px;
  color: #000;
  background-color: white;
  border: 1px solid black;
  z-index: 3;
  user-select: none;
  cursor: pointer;
}
.logo-container {
  position: absolute;
  top: var(--logo-top);
  right: var(--logo-right);
  width: var(--logo-width);
  height: var(--logo-height);
  z-index: 5;
}
.sidebar {
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
  color: var(--primary-font-color);
  background-color: var(--sidebar-bg-color);
  width: var(--sidebar-width);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  font-size: var(--sidebar-font-size);
  z-index: 5;
  box-shadow: 1px 0px 15px #00000040;
}
.sidebar div:first-child {
  padding-top: var(--sidebar-first-p);
}
.sidebar div:last-child {
  padding-bottom: var(--sidebar-last-pb);
}
.sb-btn {
  cursor: pointer;
  user-select: none;
}
.content-container {
  flex-grow: 1;
  padding-bottom: 130px; 
  position: relative;
}
.content-item {
  position: absolute;
  bottom: 20px;
  top: 0px;
  left: 0px;
  z-index:3;
  width: var(--sidebar-drawer-width);
}
/* Transition */
.content-enter-active,
.content-leave-active {
  transition: all 0.5s ease;
  
}

.content-enter-from,
.content-leave-to {
  left: calc(-1 * var(--sidebar-drawer-width));
  opacity: 0;
}
</style>
